<!-- VendorDetailsOpportunitiesTab.vue -->

<template>

  <div id="opportunities" class="tab-pane">
    <div class="p-3 shadow-sm bg-white rounded">
      <div v-if="!isFetching('fetchingVendorOpps') && isDataFetched">
        <ReusableOpportunitiesTable :records="records" @showAlert="showAlert" @showError="showError" />
      </div>

      <div v-else class="d-flex justify-content-center p-5">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import ReusableOpportunitiesTable from '@/components/ReusableOpportunitiesTable.vue';

export default {
  name: 'VendorDetailsOpportunitiesTab',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
    recordId: {
      type: String,
      required: true,
    },
  },
  components: {
    ReusableOpportunitiesTable,
  },

  data() {
    return {
      isDataFetched: false,
      records: [],
    };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',
      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    showAlert(type, message) {
      this.$emit('showAlert', type, message);
    },

    showError(errorMessage) {
      this.$emit('showError', errorMessage);
    },

    async fetchRelatedRecords() {
      try {
        this.records = await this.$store.dispatch('fetchRelatedRecords', {
          parentTableName: 'Vendors',
          childTableName: 'Opportunities',
          recordId: this.recordId,
          relatedFieldName: 'Opps',
          stateVariable: 'vendorOpps',
          fetchingStateVariable: 'fetchingVendorOpps',
        });

        this.isDataFetched = true;

      } catch (error) {
        this.$emit('showAlert', 'danger', `Error fetching related records: ${error.message}`);
        console.error(error);

      }
    }
  },

  async mounted() {
    await this.fetchRelatedRecords();
  },

  created() { },
};
</script>